<div
  *ngIf="companies.length"
  (scroll)="onScroll($event)"
  class="sp-width__full sp-overflow__x-scroll sp-position__relative sp-card">
  <table
    mat-table
    [dataSource]="companies"
    class="sp-width__full">
    <ng-container matColumnDef="company_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.ID_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <app-shared-id
          [content]="company.company_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="business_name">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.BUSINESS_NAME_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized sp-text__bold">{{ company.business_name || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.STATUS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div class="sp-row__align">
          <div
            class="sp-circle__xs sp-margin__right"
            [matTooltip]="getCompanyStatusLabel(company) | translate"
            [ngClass]="getCompanyStatusBackgroundClass(company)"></div>
          <h5 class="sp-color__primary">{{ getCompanyStatusLabel(company) | translate }}</h5>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="created_at">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.REGISTRATION_DATE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.created_at | date : 'short' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="owner_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'ORDERS.OWNER_COLUMN_LABEL' | translate }} ID </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <app-shared-id
          [content]="company.owner_id"
          [content_class]="'sp-color__primary'"
          [is_shrinked_id]="true"></app-shared-id>
      </td>
    </ng-container>

    <ng-container matColumnDef="owner_email">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized"> {{ 'ORDERS.OWNER_COLUMN_LABEL' | translate }} email </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.owner_email || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="vat">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.VAT_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.vat || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="sales_network_id">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'COMPANIES.SALES_NETWORK_ID_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.sales_network_id || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="revenues">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.REVENUES_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ getRevenuesRange(company) || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="website">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'STORES.WEBSITE_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <span class="sp-color__primary sp-text__ellipsized"> {{ company.website || '-' }} </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th
        mat-header-cell
        *matHeaderCellDef>
        <span class="sp-text__ellipsized">
          {{ 'ORDERS.ACTIONS_COLUMN_LABEL' | translate }}
        </span>
      </th>
      <td
        mat-cell
        *matCellDef="let company">
        <div
          *ngIf="company.archived_note"
          class="sp-row__align sp-margin">
          <button
            mat-icon-button
            class="sp-icon__button sp-icon__button-dark sp-margin__left"
            [matTooltip]="'GENERAL.SEE_DETAILS_CTA' | translate">
            <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
          </button>
          <button
            (click)="onNoteClick(company); $event.stopPropagation()"
            mat-icon-button
            class="sp-icon__button sp-icon__button-accent sp-margin__left"
            [matTooltip]="'GENERAL.NOTE_LABEL' | translate">
            <mat-icon> description</mat-icon>
          </button>
        </div>

        <p
          *ngIf="!company.archived_note"
          class="sp-text__center">
          -
        </p>
      </td>
    </ng-container>

    <tr
      mat-header-row
      *matHeaderRowDef="displayed_columns; sticky: true"></tr>
    <tr
      mat-row
      class="sp-cursor__pointer"
      *matRowDef="let row; columns: displayed_columns"
      (click)="onDetailsClick(row)"></tr>
  </table>
</div>
